
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0052B4","d":"M256 512c31.314 0 61.311-5.632 89.043-15.923L356.174 256l-11.13-240.077C317.311 5.633 287.314 0 256 0s-61.311 5.633-89.043 15.923L155.826 256l11.13 240.077C194.689 506.368 224.686 512 256 512z"}}),_c('path',{attrs:{"d":"M0 256c0 110.071 69.472 203.906 166.957 240.077V15.923C69.472 52.094 0 145.929 0 256zM345.043 15.923v480.155C442.528 459.906 512 366.071 512 256S442.528 52.094 345.043 15.923z","fill":"#A2001D"}}),_c('g',{attrs:{"fill":"#FFDA44"}},[_c('path',{attrs:{"d":"M122.435 256h22.261v89.043h-22.261zM33.391 256h22.261v89.043H33.391z"}}),_c('circle',{attrs:{"cx":"89.043","cy":"289.391","r":"22.261"}}),_c('circle',{attrs:{"cx":"89.043","cy":"211.478","r":"11.13"}}),_c('path',{attrs:{"d":"M66.783 322.783h44.522v22.261H66.783zM66.783 233.739h44.522V256H66.783zM89.043 133.565l7.884 24.26h25.508L101.8 172.819l7.878 24.26-20.635-14.994-20.634 14.994 7.878-24.26-20.635-14.994H81.16z"}})])])
          )
        }
      }
    